import React from 'react';

interface InputProps {
  id?: string;
  name?: string;
  type?: 'text' | 'number' | 'datetime-local' | 'email' | 'password';
  value?: string | number;
  defaultValue?: string | number;
  placeholder?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  required?: boolean;
  className?: string;
  step?: string | number;
  min?: string | number;
  max?: string | number;
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(({
  id,
  name,
  type = 'text',
  value,
  defaultValue,
  placeholder,
  onChange,
  onBlur,
  disabled = false,
  required = false,
  className = '',
  step,
  min,
  max,
}, ref) => {
  const baseClasses = 'block w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm placeholder-gray-400 dark:placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:bg-gray-100 disabled:dark:bg-gray-700 disabled:cursor-not-allowed';

  return (
    <input
      ref={ref}
      id={id}
      name={name}
      type={type}
      value={value}
      defaultValue={defaultValue}
      placeholder={placeholder}
      onChange={onChange}
      onBlur={onBlur}
      disabled={disabled}
      required={required}
      step={step}
      min={min}
      max={max}
      className={`${baseClasses} ${className}`}
    />
  );
});

Input.displayName = 'Input';
